/** Risolve l'orario di un messaggio in modo robusto (envelope > id epoch > now). */

import { t } from '../i18n/index.ts'

const MIN_SANE_TS = Date.UTC(2020, 0, 1)
const MAX_FUTURE_MS = 24 * 60 * 60 * 1000

export function resolveMessageTimestamp(opts: {
  envelopeTs?: number | null
  messageId?: string | null
  fallback?: number
}): number {
  const now = Date.now()
  const maxOk = now + MAX_FUTURE_MS
  const candidates = [
    opts.envelopeTs,
    opts.messageId != null ? Number.parseInt(String(opts.messageId), 10) : NaN,
    opts.fallback,
    now,
  ]
  for (const raw of candidates) {
    if (typeof raw !== 'number' || !Number.isFinite(raw)) continue
    const ts = Math.trunc(raw)
    if (ts >= MIN_SANE_TS && ts <= maxOk) return ts
  }
  return now
}

export function formatMessageDayLabel(ts: number): string {
  const d = new Date(ts)
  const today = new Date()
  const yday = new Date()
  yday.setDate(today.getDate() - 1)
  const sameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  if (sameDay(d, today)) return t('common_today')
  if (sameDay(d, yday)) return t('common_yesterday')
  return d.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
}

export function sameCalendarDay(a: number, b: number): boolean {
  const da = new Date(a)
  const db = new Date(b)
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  )
}
